/**
 * Compact number formatting — exact below 10k, abbreviated above.
 * e.g. 9999 → "9,999", 54321 → "54.3K", 1234567 → "1.2M"
 */
export default function formatCompact(n) {
  if (n < 10000) return n.toLocaleString();
  if (n < 1000000) return `${(n / 1000).toFixed(n < 100000 ? 1 : 0)}K`;
  return `${(n / 1000000).toFixed(n < 10000000 ? 1 : 0)}M`;
}
